import React from 'react';
import styled from '@emotion/styled';
import { useNavigate } from 'react-router-dom';
import { arrowIcon, billingIcon, clientIcon, employeesIcon, projectIcon } from '../../utils/icon';

export const type = {
  NOPROJECT: 'Available Resources',
  NONBILLABLE: 'Occupied Without Billing',
  TOTAL_EMPLOYEES: 'Total Employees',
  TOTAL_LEAVES_BY_EMPLOYEES: 'Total leaves by employees',
  ACTIVE_DAYS: 'Active Days',
  TOTAL_PROJECTS: 'Total Projects',
  BILLABLE: 'Occupied Resources',
  BILLING_HOURS: 'Billing Hours',
  DEPARTMENTS_BILLING: 'Department Billing',
  ACTIVE_PROJECT_BILLING: 'Active Project Billing',
  CLIENT_TOTAL_BILLING: 'Client Total biliing'
};

const employeeReportType = [
  { label: type.NOPROJECT, value: type.NOPROJECT },
  { label: type.NONBILLABLE, value: type.NONBILLABLE },
  { label: type.ACTIVE_DAYS, value: type.ACTIVE_DAYS },
  { label: type.BILLABLE, value: type.BILLABLE },
  { label: type.TOTAL_LEAVES_BY_EMPLOYEES, value: type.TOTAL_LEAVES_BY_EMPLOYEES }
];

const bilingReportType = [
  { label: type.DEPARTMENTS_BILLING, value: type.DEPARTMENTS_BILLING },
  { label: type.ACTIVE_PROJECT_BILLING, value: type.ACTIVE_PROJECT_BILLING },
  { label: type.BILLING_HOURS, value: type.BILLING_HOURS }
];

const clientReportType = [{ label: type.CLIENT_TOTAL_BILLING, value: type.CLIENT_TOTAL_BILLING }];

const projectReportType = [
  // { label: type.TOTAL_PROJECTS, value: type.TOTAL_PROJECTS },
  { label: type.ACTIVE_PROJECT_BILLING, value: type.ACTIVE_PROJECT_BILLING }
];

const ViewReport = () => {
  const navigate = useNavigate();

  const onClick = (value) => {
    navigate(`/reports/type`, { state: { reportType: value } });
  };

  return (
    <Container>
      <CardWrapper>
        <Card bg="#adeeff">
          <CardHeader>
            {employeesIcon}
            Employees
          </CardHeader>
          <CardList>
            {employeeReportType.map((item, index) => (
              <Item key={index} onClick={() => onClick(item.value)}>
                {item.label} {arrowIcon}
              </Item>
            ))}
          </CardList>
        </Card>

        <Card bg="#fff2cc">
          <CardHeader>
            {billingIcon}
            Billing IDs
          </CardHeader>
          <CardList>
            {bilingReportType?.map((item, index) => (
              <Item key={index} onClick={() => onClick(item.value)}>
                {item.label} {arrowIcon}
              </Item>
            ))}
          </CardList>
        </Card>
        <Card bg="#b9ffef">
          <CardHeader>
            {projectIcon}
            Projects
          </CardHeader>
          <CardList>
            {projectReportType?.map((item, index) => (
              <Item key={index} onClick={() => onClick(item.value)}>
                {item.label} {arrowIcon}
              </Item>
            ))}
          </CardList>
        </Card>
        <Card bg="#e4c8ff">
          <CardHeader>
            {clientIcon}
            Client
          </CardHeader>
          <CardList>
            {clientReportType?.map((item, index) => (
              <Item key={index} onClick={() => onClick(item.value)}>
                {item.label} {arrowIcon}
              </Item>
            ))}
          </CardList>
        </Card>
      </CardWrapper>
    </Container>
  );
};

export default ViewReport;

// Styled Components
const Container = styled.div`
  background: #f7f9fc;
  border-radius: 12px;
  padding: 10px 0;
  height: 100%;
`;

const CardWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  background: #fff;
  border-radius: 12px;

  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

const Card = styled.div`
  background: #fff;
  border-radius: 10px;
  padding: 15px;

  & > div:first-child {
    background: ${(props) => props.bg || '#eee'};
  }
`;

const CardHeader = styled.div`
  font-family: Plus Jakarta Sans;
  font-weight: 500;
  font-style: Medium;
  font-size: 18px;
  line-height: 120%;
  letter-spacing: 0%;
  color: #111827;
  display: flex;
  align-items: center;
  padding: 18px 10px;
  gap: 10px;
  border-radius: 12px;
`;

const CardList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;
const Item = styled.p`
  margin: 0;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #000000ff;
  display: flex;
  padding: 20px 10px;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e5e7eb;
  width: 100%;
  cursor: pointer;
  transition: color 0.2s ease;

  svg {
    transition: color 0.2s ease, transform 0.2s ease;
  }

  &:hover {
    color: #d90202;

    svg {
      color: #d90202; /* arrow color changes with hover */
      transform: translateX(4px) scale(1.2);
    }
  }

  &:last-child {
    border-bottom: none;
  }
`;
